module.exports = __webpack_public_path__ + "static/media/BladeRX_18B_adapter.53927ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/BladeRX_18B_adapter.jpg
// module id = 831
// module chunks = 0